const language = 'spanish';
export const langDir = 'ltr';

export default language;
